import { CustomThemeToken } from '@/theme';
import styled from 'styled-components';

interface ContainerProps {
  width: number;
  height: number;
  $mapView: number;
  theme: { token: CustomThemeToken };
  $textColor: string;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: 0 ${({ theme: { token } }) => token.paddingXXS}px 0 0;

  .background {
    position: absolute;
    top: 0;
    right: 0;
    z-index: ${({ $mapView }) => $mapView};
    margin-top: -${({ theme: { token } }) => token.marginSM}px;
  }

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${({ theme: { token } }) => token.paddingXS}px 0 ${({ theme: { token } }) => token.padding}px;
    width: 100%;
    height: 50px;

    .control-icon {
      width: 29px;
      height: 29px;
      margin-right: ${({ theme: { token } }) => token.marginXS}px;
      z-index: 1;
    }

    .name {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }

    .model {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }
  }

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ $textColor }) => $textColor};
    text-transform: capitalize;
    text-align: center;
  }

  .node-body {
    display: flex;
    margin-left: ${({ theme: { token } }) => token.margin}px;

    section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 67px;
      width: 73%;
      padding: ${({ theme: { token } }) => token.paddingXXS}px;

      .metrics-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 15px;
        justify-items: center;

        .metrics-list-item {
          .metrics-list-item-value {
            font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
            font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
            color: ${({ theme: { token } }) => token.colorTextTertiary};
            &.highlighted {
              color: ${({ theme: { token } }) => token.colorText};
            }
          }

          .metrics-list-item-label {
            font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
            margin-left: ${({ theme: { token } }) => token.marginXXS}px;
            color: ${({ theme: { token } }) => token.colorTextSecondary};
          }
        }
      }
    }

    .right-cell {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
`;
